import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TriggerTypePipe } from './trigger-type.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TriggerTypePipe
  ],
  exports: [
    TriggerTypePipe
  ]
})
export class TriggerTypeModule { }
